import React from 'react';
import { useTranslation } from 'react-i18next';
import img from '../images/home-to-home.webp'; 
import img2 from '../images/goods_storage.webp';
import img3 from '../images/parts_transportation.webp';
import img4 from '../images/intercity.webp';
import img5 from '../images/international.webp';

const We_offer = () => {
    const { t } = useTranslation();

    return (
        <div id="offer" className="bg-gray-100 py-12">
            <section>
                <div className="my-4 py-4">
                    <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">{t('offer.title')}</h2>
                    
                    <div className='flex justify-center'>
                        <div className='w-44 border-b-4 border-blue-900'></div>
                    </div>
                    <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-blue-900">
                        {t('offer.subtitle')}
                    </h2>
                </div>

                <div className="px-12">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
                        {['home', 'storage', 'parts', 'intercity', 'international'].map((key, index) => (
                            <div key={key} className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group">
                                <div className="m-2 text-justify text-sm">
                                    <img
                                        alt="card img"
                                        className="h-50 w-56 mx-auto rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
                                        src={[img, img2, img3, img4, img5][index]}
                                    />
                                    <h2 className="font-semibold my-4 text-2xl text-center">{t(`offer.cards.${key}.title`)}</h2>
                                    <p className="text-md font-medium">{t(`offer.cards.${key}.desc`)}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section>
                <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6">
                    <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left">
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                            <div className='text-blue-900 mb-4'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#1e3a9e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck-electric-icon lucide-truck-electric"><path d="M14 19V7a2 2 0 0 0-2-2H9"/><path d="M15 19H9"/><path d="M19 19h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 9.38a1 1 0 0 0-.78-.38H14"/><path d="M2 13v5a1 1 0 0 0 1 1h2"/><path d="M4 3 2.15 5.15a.495.495 0 0 0 .35.86h2.15a.47.47 0 0 1 .35.86L3 9.02"/><circle cx="17" cy="19" r="2"/><circle cx="7" cy="19" r="2"/></svg>
                            </div>
                            <h3 className="text-3xl text-blue-900 font-bold">
                                {t('offer.moveTitle')}
                            </h3>
                            <p className='my-3 text-xl text-gray-600 font-semibold'>{t('offer.moveDesc')}</p>
                        </div>
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                            <div className='text-blue-900 mb-4'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#1e3a9e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-warehouse-icon lucide-warehouse"><path d="M18 21V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v11"/><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 1.132-1.803l7.95-3.974a2 2 0 0 1 1.837 0l7.948 3.974A2 2 0 0 1 22 8z"/><path d="M6 13h12"/><path d="M6 17h12"/></svg>
                            </div>
                            <h3 className="text-3xl text-blue-900 font-bold">
                                {t('offer.storeTitle')}
                            </h3>
                            <p className='my-3 text-xl text-gray-600 font-semibold'>{t('offer.storeDesc')}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default We_offer;
